import { InMemoryCache } from '@apollo/client'
import { relayStylePagination } from '@apollo/client/utilities'

export function createCache(): InMemoryCache {
  return new InMemoryCache({
    typePolicies: {
      Query: {
        fields: {
          venueMerchantLocations: relayStylePagination(),
          geoSearchMerchantLocations: relayStylePagination()
        }
      },
      Cart: {
        keyFields: ['uuid'],
        fields: {
          cartItems: {
            merge(existing, incoming) {
              return incoming
            }
          }
        }
      },
      CartItem: {
        keyFields: ['uuid']
      },
      MerchantLocation: {
        fields: {
          menus: {
            merge(existing, incoming) {
              return incoming
            }
          }
        }
      }
    }
  })
}
